<app-spinner-overlay></app-spinner-overlay>
<app-lista-tabellare
  #tabella
  [fnCaricamentoDati]="fnCaricamentoDati"
  [colonne]="colonne"
  [filtri]="filtri"
  (bottoniListaClick)="bottoniListaClick($event)"
>
  <div btnEnd>
    <button
      [disabled]="!isCreaAzienda()"
      mat-flat-button
      *ngIf="this.utenteService.isPermessoAttivo('CREATE_AZIENDA')"
      class="primary-button"
      color="primary"
      (click)="crea()"
    >
      Nuova
    </button>
  </div>
</app-lista-tabellare>
